<template>
  <div>
    <section class="hero has-background-white-bis" style="box-shadow: 0px 6px 14px -4px rgba(196,196,196,1);">
      <div class="hero-body">
        <div class="container" v-if="showName=='true'">        
          <h1 class="title is-capitalized">
            {{ unidad.name}}
          </h1>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Año desde:">
              <multiselect v-model="minYear"
                           :options="year_options"
                           :searchable="true"
                           :close-on-select="true"
                           placeholder="Elija un año"
                           :allow-empty="true"
                           selectLabel="Presione para seleccionar"
                           selectedLabel="Seleccionado"
                           deselectLabel="Presione para deseleccionar"
              ></multiselect>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Año hasta:"
                     :type="{ 'is-danger': verifyYears }"
                     :message="{ 'Año hasta no puede ser menor al Año desde': verifyYears }">
              <multiselect v-model="maxYear"
                           :options="year_options"
                           :searchable="true"
                           :close-on-select="true"
                           placeholder="Elija un año"
                           :allow-empty="true"
                           selectLabel="Presione para seleccionar"
                           selectedLabel="Seleccionado"
                           deselectLabel="Presione para deseleccionar"
              ></multiselect>
            </b-field>
          </div>
        </div>
        <div class="box"> 
          <div class="columns is-centered has-text-centered">
            <b-field label="Entidades EFUSACH:"/>
          </div>
          <div class="columns is-centered has-text-centered">
            <b-checkbox class="column is-centered" v-for="item in entidades" :key="item.id" v-model="entidadesSel" :native-value="item.id">
                {{item.initials}}
            </b-checkbox>
          </div>
        </div>
        <div class="columns">
          <div class="column ">
            <div class="is-pulled-right">
              <br>
              <b-field label=" ">
                <b-tooltip label="Seleccione un rango de fechas para filtrar actividad académica."
                           position="is-left">
                  <b-button type="is-info" icon-left="search" @click="applyFilter">
                    Aplicar filtros
                  </b-button>
                </b-tooltip>
              </b-field>
            </div>

          </div>
        </div>
      </div>

    </section>
    <section>
      <div class="box">
        <div class="container">
          <b-tabs position="is-centered" @input="changeTab">
            <b-tab-item v-for="item in items"
                        :value="item.content"
                    v-bind:key="item.content"
                    :label="item.tab"
                    :icon="item.icon"
                    v-if="item.permission">
        </b-tab-item>

      </b-tabs>
      <!-- COMPONENTE AQUI -->
      <keep-alive>
        <component  v-bind:is="currentTabComponent" :object-id="unitId"
                   :currentYear="year" :min-year="minYear" :max-year="maxYear" :change-filter="changeFilter" :hide-update="true" :unit-id="unitId" :is-faculty="isFaculty" :entidades="entidades" :entidades-sel="entidadesSel"></component>
          </keep-alive>
          <!-- FIN COMPONENTE -->

        </div>
      </div>
    </section>

      <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>

  </div>

</template>
<script>
import Summary from "./TransactionSummaryTab.vue";
import Excedentes from "./TransactionExcedentesTab.vue";
import Egresos from "./TransactionEgresosTab.vue";
import axios from "axios";
export default {
  components:{
    Summary, Excedentes, Egresos
  },
  props:[
    'unitId','cargoPrincipal','isFaculty','showName'
  ],
  data(){
    return{
      units:[{name: " ", id:0}],
      isLoading:false,
      currentTab: 'Summary',
      items: [
        {tab: 'Resumen',content:'Summary',icon:"address-card", permission: true},
        {tab: 'Códigos EFUSACH',content:'Excedentes',icon:"file-alt", permission: true},
        {tab: 'Egresos',content:'Egresos',icon:"clipboard-list", permission: true},
      ],
      year:new Date().getFullYear(),
      minYear:new Date().getFullYear() - 5,
      maxYear:new Date().getFullYear(),
      year_options:Array.from({length:(new Date().getFullYear()-2000+1)},(v,k)=>k+2000).reverse(),
      currentYear:null,
      historicFilter:false,
      verifyYears:false,
      unidad: {},
      changeFilter:0,
      entidades: [],
      entidadesSel: [],

    }
  },
  created(){
    let vm = this;
    vm.isLoading=true;
    axios
        .get("/sdt_surpluses/form-data.json")
        .then(res => {
          vm.unidad = res.data.unidades.find(uni => uni.id == vm.unitId);      
          vm.entidades = res.data.entidades;
          vm.entidadesSel = res.data.entidades.map(elemento => elemento.id);
          vm.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          vm.isLoading=false;
        });

  },
  methods:{
    changeTab: function(value){
      this.currentTab = value
    },
    applyFilter(){
      if (this.minYear!= null && this.maxYear!=null){
        if(this.minYear > this.maxYear){
          this.verifyYears = true
        }
        else{
          this.verifyYears = false
          if (this.changeFilter == 0){
            this.changeFilter = 1
          }
          else{
            this.changeFilter = 0
          }
        }
      }
      else{
        this.verifyYears = false
        if (this.changeFilter == 0){
          this.changeFilter = 1
        }
        else{
          this.changeFilter = 0
        }
      }
    }

  },
  computed:{
    currentTabComponent: function () {
      return this.currentTab
    }
  }
}
</script>